
<div class="breadcrumb-wrapper">
  <div class="container fw-b breadcrumb-container">
    <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
  </div>
</div>
<div class="container mt-4 mb-5">
  <div class="product-detail-wrapper">
    <div class="row mt-3 product-details-row">
      <!-- Product Images Section -->
      <div class="col-md-7">
        <div class="product-image-gallery">
          <div
            class="main-image-container"
            #mainImageContainer
            (mouseenter)="onMainImageEnter()"
            (mouseleave)="onMainImageLeave()"
            (mousemove)="onMainImageMove($event)">
            <img class="main-product-image" [hidden]="!imageLoaded" (load)="onImageLoad()" [src]="imgurl"
              alt="Product Image">
            <ngx-skeleton-loader *ngIf="!imageLoaded" [theme]="{width: '100%',
            height: '405px',
            position: 'relative'}" count="1"></ngx-skeleton-loader>
            <button class="wishlist-heart-btn zoom-ignore" *ngIf="isLoggedIn" (click)="addWishlist(productDetails?._id)">
              <i class="fa fa-heart-o" *ngIf="productDetails?.isLike == false"></i>
              <i class="fa fa-heart" *ngIf="productDetails?.isLike == true"></i>
            </button>
            <button class="wishlist-heart-btn zoom-ignore" *ngIf="!isLoggedIn" (click)="showMessage()" [routerLink]="['/login']">
              <i class="fa fa-heart-o" *ngIf="productDetails?.isLike == false"></i>
              <i class="fa fa-heart" *ngIf="productDetails?.isLike == true"></i>
            </button>

            <!-- Zoom lens overlay -->
            <div
              class="zoom-lens"
              *ngIf="isZoomActive"
              [ngStyle]="{
                left: zoomLensLeft + 'px',
                top: zoomLensTop + 'px',
                width: zoomLensSize + 'px',
                height: zoomLensSize + 'px'
              }">
            </div>
          </div>
          <div class="thumbnail-gallery" *ngIf="productDetails?.productImage?.length">
            <div class="thumbnail-item" *ngFor="let item of productDetails?.productImage; let i = index"
              [class.active]="imgurl === item" (click)="changeProductimage(item)">
              <img class="thumbnail-image" [src]="item" alt="Product thumbnail">
            </div>
          </div>

          <!-- Side zoom preview -->
          <div class="zoom-preview" *ngIf="isZoomActive">
            <div
              class="zoom-preview-inner"
              [ngStyle]="{
                'background-image': 'url(' + imgurl + ')',
                'background-position': zoomBackgroundPosition
              }">
            </div>
          </div>
        </div>
      </div>

      <!-- Product Details Section -->
      <div class="col-md-5">
        <div class="product-details-section">
          <!-- Shimmer Loader for Product Title -->
          <ngx-skeleton-loader *ngIf="!isLoading || !productDetails" [theme]="{
            width: '90%',
            height: '32px',
            'border-radius': '8px',
            'margin-bottom': '15px'
          }"></ngx-skeleton-loader>
          <!-- Product Title -->
          <h1 class="product-title" *ngIf="isLoading && productDetails">{{productDetails?.productName}}</h1>

          <!-- Product Description & Specs under title -->
          <div class="product-meta" *ngIf="isLoading && productDetails">
            <p class="product-short-description" *ngIf="productDetails?.description">
              <span *ngIf="!isFullDescriptionVisible">
                {{ productDetails?.description | slice:0:210 }}
                <ng-container *ngIf="productDetails?.description?.length > 210">...</ng-container>
              </span>
              <span *ngIf="isFullDescriptionVisible">
                {{ productDetails?.description }}
              </span>
              <button
                *ngIf="productDetails?.description?.length > 210"
                type="button"
                class="read-more-toggle"
                (click)="toggleDescription()">
                <span class="read-more-text">
                  {{ isFullDescriptionVisible ? 'Read less' : 'Read more' }}
                </span>
                <i class="fa fa-chevron-down read-more-chevron" [ngClass]="{'expanded': isFullDescriptionVisible}"></i>
              </button>
            </p>

            <!-- Primary Size / Value Selector under description -->
            <div class="size-label-and-row" *ngIf="productDetails?.priceSizeDetails?.length">
              <span class="size-label">Size / Value : </span>
              <div class="size-circle-row">
              <button
                type="button"
                class="size-circle"
                *ngFor="let item of productDetails?.priceSizeDetails; let i = index"
                (click)="price(item?.weight, item?.volume, item?.price,item?.quantity,item?.value,item?.id,item?.unit,i)"
                [class.size-circle--active]="value == item?.value"
                [class.size-circle--disabled]="!item?.quantity"
                [disabled]="!item?.quantity">
                {{ item?.value }}
              </button>
              </div>
            </div>
          </div>

          <!-- Rating Section
          <div class="rating-section">
            <div class="stars">
              <i class="fa fa-star" *ngFor="let star of [1,2,3,4,5]"></i>
            </div>
            <span class="rating-text">(4.5)</span>
          </div> -->

          <!-- Pricing Section -->
          <!-- Shimmer Loader for Pricing -->
          <div class="pricing-section" *ngIf="!isLoading || !productDetails">
            <ngx-skeleton-loader [theme]="{
              width: '150px',
              height: '40px',
              'border-radius': '8px',
              'margin-bottom': '10px'
            }"></ngx-skeleton-loader>
            <ngx-skeleton-loader [theme]="{
              width: '100px',
              height: '20px',
              'border-radius': '8px'
            }"></ngx-skeleton-loader>
          </div>
          <div class="pricing-section" *ngIf="isLoading && productDetails">
            <!-- Discounted / Current Price -->
            <div class="current-price">
              {{productDetails?.isDealActive ? getPrice(((mrp ? mrp : productDetails?.priceSizeDetails[0]?.price) *
                (1 - productDetails?.dealDiscount / 100)) | currency: 'ZAR':'R')
              : getPrice(
              (mrp ? mrp : productDetails?.priceSizeDetails[0]?.price) |
              currency: 'ZAR':'R'
              )
              }}
            </div>

            <!-- Original Price (only if deal is active) -->
            <div class="original-price" *ngIf="productDetails?.isDealActive">
              {{
              getPrice(
              (mrp ? mrp : productDetails?.priceSizeDetails[0]?.price) |
              currency: 'ZAR':'R'
              )
              }}
            </div>

            <!-- Discount Badge -->
            <div class="discount-badge" *ngIf="productDetails?.isDealActive">
              {{ productDetails?.dealDiscount }}% OFF
            </div>
          </div>


          <!-- Quantity and Action Buttons Row -->
          <!-- Shimmer Loader for Buttons -->
          <div class="quantity-and-actions-row" *ngIf="!isLoading || !productDetails">
            <ngx-skeleton-loader [theme]="{
              width: '120px',
              height: '48px',
              'border-radius': '8px',
              'margin-right': '10px'
            }"></ngx-skeleton-loader>
            <ngx-skeleton-loader [theme]="{
              width: '150px',
              height: '48px',
              'border-radius': '8px',
              'margin-right': '10px'
            }"></ngx-skeleton-loader>
            <ngx-skeleton-loader [theme]="{
              width: '48px',
              height: '48px',
              'border-radius': '8px'
            }"></ngx-skeleton-loader>
          </div>
          <div class="quantity-and-actions-row" *ngIf="isLoading && productDetails">
            <!-- Quantity Label and Selector -->
            <div class="quantity-wrapper">
              <div class="stock-status" *ngIf="quantity || productDetails?.priceSizeDetails?.[0]?.quantity">
                <span class="stock-dot"></span>
                <span class="stock-text">
                  In Stock ({{ quantity || productDetails?.priceSizeDetails?.[0]?.quantity }} available)
                </span>
              </div>
              <label class="quantity-label">Quantity:</label>
              <div class="quantity-selector">
                <button type="button" class="quantity-btn"
                  (click)="decreaseQuantity(); $event.stopPropagation()">
                  <i class="fa fa-minus quantity-icon" aria-hidden="true"></i>
                </button>
                <input type="number" class="quantity-input" [(ngModel)]="selectedQuantity" min="1"
                  [max]="quantity || productDetails?.priceSizeDetails?.[0]?.quantity || 999"
                  (input)="calculateTotalPrice()" (blur)="calculateTotalPrice()">
                <button type="button" class="quantity-btn"
                  (click)="increaseQuantity(); $event.stopPropagation()">
                  <i class="fa fa-plus quantity-icon" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <!-- Add to Cart Button (always visible, disabled when out of stock) -->
            <button class="add-to-cart-btn" (click)="addToCart()" [disabled]="quantity == 0">
              <i class="fa fa-shopping-cart"></i>
              Add to Cart
            </button>
            <button class="add-to-cart-btn" *ngIf="quantity == 0" disabled>
              Out of Stock
            </button>

            <!-- Wishlist Button -->
            <button class="wishlist-action-btn" *ngIf="isLoggedIn" (click)="addWishlist(productDetails?._id)">
              <i class="fa fa-heart-o" *ngIf="productDetails?.isLike == false"></i>
              <i class="fa fa-heart" *ngIf="productDetails?.isLike == true"></i>
              Add to Wishlist
            </button>
            <button class="wishlist-action-btn" *ngIf="!isLoggedIn" (click)="showMessage()" [routerLink]="['/login']">
              <i class="fa fa-heart-o"></i>
              Add to Wishlist
            </button>
          </div>

          <!-- Key Features Section -->
          <div class="key-features-section">
            <h3 class="key-features-title">Key Features</h3>
            <div class="feature-cards-section">
              <div class="feature-card">
                <div class="feature-icon">
                  <i class="fa fa-shield"></i>
                </div>
                <div class="feature-text">100% Secure</div>
              </div>
              <div class="feature-card">
                <div class="feature-icon">
                  <i class="fa fa-refresh"></i>
                </div>
                <div class="feature-text">30-Day Returns</div>
              </div>
              <div class="feature-card">
                <div class="feature-icon">
                  <i class="fa fa-truck"></i>
                </div>
                <div class="feature-text">Free Delivery</div>
              </div>
              <div class="feature-card">
                <div class="feature-icon">
                  <i class="fa fa-headphones"></i>
                </div>
                <div class="feature-text">24/7 Support</div>
              </div>
            </div>
          </div>

          <!-- Key Features -->
          <!--
          <div class="key-features">
            <h3 class="features-title">Key Features:</h3>
            <div class="features-grid">
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="fa fa-volume-up"></i>
                </div>
                <span class="feature-text">Premium sound quality</span>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="fa fa-battery-full"></i>
                </div>
                <span class="feature-text">30-hour battery life</span>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="fa fa-volume-off"></i>
                </div>
                <span class="feature-text">Active Noise Cancellation</span>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="fa fa-bluetooth"></i>
                </div>
                <span class="feature-text">Wireless Bluetooth 5.0</span>
              </div>
              <div class="feature-item">
                <div class="feature-icon">
                  <i class="fa fa-bolt"></i>
                </div>
                <span class="feature-text">Quick charge technology</span>
              </div>
            </div>
          </div>
          -->
        </div>
      </div>
    </div>
  </div>

  <!-- Product Information Tabs removed as requested -->
</div>
<!-- service slider -->
<div class="related-products-section" *ngIf="iaAPILoaded && serviceData?.length">
  <div class="related-products-header">
    <h2 class="related-products-title">Related Products</h2>
  </div>
  <div class="related-products-grid">
    <ng-container *ngFor="let data of serviceData; let i = index">
      <div class="related-product-card" *ngIf="productDetails._id !== data._id">
        <product-card [data]="data" (on_Click)="viewProducts(data?._id)"></product-card>
      </div>
    </ng-container>
  </div>
</div>

<div class="related-products-section" *ngIf="!iaAPILoaded">
  <div class="related-products-header">
    <h2 class="related-products-title">Related Products</h2>
  </div>
  <div class="related-products-grid">
    <ng-container *ngFor="let data of length(4)">
      <div class="related-product-card">
        <product-card [data]="data" width="228px" height="300px"></product-card>
      </div>
    </ng-container>
  </div>
</div>
<div class="modal fade" id="interestedPriceModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header modal-header-custom">
        <h5 class="modal-title modal-title-custom" id="exampleModalLabel">
          <img class="modal-logo-img" src="assets/img/whiteLogo.png" alt="" />
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <!-- <span aria-hidden="true" style="color: white;">&times;</span> -->
        </button>
      </div>
      <div class="modal-body">
        <div class="form" *ngIf="showInterestedPriceModal">
          <div class="row justify-content-between">
            <div class="col-md-12 text-center">
              <img class="custom-img h-100 change-img modal-product-img"
                [src]="productDetails?.productImage[0]" />
            </div>

            <div class="col-md-12 text-left modal-padding-zero">
              <div class="form-group d-flex">
                <label for="size" style="margin-top: 10px; min-width: 126px">Size/Value :-
                </label>
                <ng-container *ngFor="let item of productDetails?.priceSizeDetails">
                  <p class="pid-1 new-loop-para" (click)="
                      price(
                        item?.price,
                        item?.quantity,
                        item?.value,
                        item?.id,
                        item?.unit
                      )
                    " [ngClass]="{ active: value == item?.value }">
                    {{ item?.value }}
                    {{ item?.unit !== "other" ? "" + item?.unit : "" }}
                  </p>
                </ng-container>
              </div>
            </div>

            <div class="col-md-12 text-left modal-padding-zero">
              <div class="form-group d-flex">
                <div class="modal-label-width">Price :-</div>
                <div class="col-6 digitalartconBox">
                  <div class="row">
                    <span>
                      {{
                      mrp
                      ? getPrice(mrp | currency : "ZAR" : "R")
                      : productDetails?.priceSizeDetails[0]?.price &&
                      getPrice(
                      productDetails?.priceSizeDetails[0]?.price
                      | currency : "ZAR" : "R"
                      )
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 text-left" style="padding: 0px">
              <!-- <div class="form-group">
                <label for="exampleInputEmail1">Interested Price</label>
                <input type="text" class="form-control"  aria-describedby="toDate"
                  placeholder="Enter Interested Price"
                
                  (keypress)="commonService.numberOnly($event)"
                  (keypress)="commonService.preventSpace($event);commonService.numberOnly($event)" 
                  onkeyup="if(this.value > 99) this.value = 99; if(this.value < 0) this.value = 0;"
                  >
              </div> -->
              <div class="form-group d-flex">
                <div>
                  <label for="exampleInputEmail1" class="modal-label-style">Interested Price:-</label>
                </div>
                <div class="col-md-6">
                  <input type="text" [(ngModel)]="interestedPrice" aria-describedby="toDate"
                    placeholder="Enter Interested Price" 
                    (keypress)="commonService.preventSpace($event); commonService.numberOnly($event)"
                    class="modal-input-bg" />
                  <div *ngIf="mrp < interestedPrice || interestedPrice <= 0" class="modal-error-text">
                    Invalid Price
                  </div>
                </div>
                <!-- <div class="error" *ngIf="mrp">
                  <p >Can not add more amount than actual amount</p>
                </div> -->
              </div>
              <div class="form-group d-flex">
                <div>
                  <label for="exampleInputEmail1" class="modal-label-style">Quantity:-</label>
                </div>
                <div class="col-md-6">
                  <input class="form-control" type="number" [(ngModel)]="intrestedQuantity"
                    (keypress)="commonService.preventSpace($event); commonService.numberOnly($event)" />
                  <div *ngIf="quantity < intrestedQuantity" class="modal-error-text">
                    Quantity should be equal or less than Available Quantity
                  </div>
                  <div *ngIf="intrestedQuantity <= 0" class="modal-error-text">
                    Quantity must be greater than 0
                  </div>
                </div>

                <!-- <div class="col-md-6">
                  <input
                    class="form-control"
                    type="number"
                    [(ngModel)]="intrestedQuantity"
                    (keypress)="commonService.preventSpace($event); commonService.numberOnly($event)"
                    (ngModelChange)="validateQuantity()"
                    min="0"
                  />
                  <div *ngIf="showValidationError" style="color: #BF1E2E;">
                    Quantity should be equal or less than Available Quantity
                  </div>
                </div> -->

                <!-- <div class="error" *ngIf="mrp">
                  <p >{{quantity}}</p>
                </div> -->
              </div>
            </div>

            <div class="form-group d-flex">
              <div class="modal-radio-container">
                <input type="radio" (change)="spordicType = 'AUTOMATIC'" name="spordaicSelection" id="auto-spordaic"
                  [checked]="spordicType === 'AUTOMATIC'" />
                <label for="auto-spordaic" class="modal-radio-label">Automatic : Buy automatically when the campaign
                  starts.</label>
              </div>
            </div>
            <div class="form-group d-flex">
              <div class="modal-radio-container">
                <input type="radio" (change)="spordicType = 'SEMIAUTOMATIC'" name="spordaicSelection" id="semi-spordaic"
                  [checked]="spordicType === 'SEMIAUTOMATIC'" />
                <label for="semi-spordaic" class="modal-radio-label">Semi Automatic : Let me review the cart before
                  purchase.</label>
              </div>
            </div>
            <div class="form-group d-flex">
              <div class="modal-radio-container">
                <input type="radio" (change)="spordicType = 'MANUAL'" name="spordaicSelection" id="manual"
                  [checked]="spordicType === 'MANUAL'" />
                <label for="manual" class="modal-radio-label">
                  Manual: Receive notification when campaign is started.</label>
              </div>
            </div>
          </div>
          <!-- <div class="col-md-12 text-center">
              <div class="form-group">
                <label for="exampleInputEmail1">Available Stock {{ campaignModel[selectedIndex].quantity - campaignModel[selectedIndex].releaseQuantity}}</label>
              </div>
            </div> -->

          <div class="col-md-12 text-center mt-3">
            <button class="btn btn-theme modal-confirm-btn" (click)="confirmInterestedPrice()" [disabled]="
                mrp < interestedPrice ||
                quantity < intrestedQuantity ||
                (interestedPrice && intrestedQuantity) == 0 ||
                (interestedPrice && intrestedQuantity) == null ||
                interestedPrice <= 0
              ">
              Confirm Price
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>